import axios, { AxiosError } from "axios"
import { toast } from "sonner"
import i18n from "i18next"

export const apiBaseURL = import.meta.env.VITE_BACKEND_BASE_URL || "/api"

const axiosClient = axios.create({
  baseURL: apiBaseURL,
  timeout: 30000, // 30 seconds timeout
  headers: {
    "Content-Type": "application/json",
    "Cache-Control": "no-cache, no-store, must-revalidate",
    Pragma: "no-cache",
    Expires: "0",
  },
})

// Add a request interceptor
axiosClient.interceptors.request.use(
  (config) => {
    // Get token from localStorage - check the correct key first
    let token = localStorage.getItem("access_token")

    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`
    }

    return config
  },
  (error) => Promise.reject(error),
)

// Add a response interceptor
axiosClient.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Handle errors globally (e.g., log out user if unauthorized)
    if (error.response?.status === 401) {
      const detail = error.response?.data as { detail?: string }
      if (detail?.detail === "Could not validate credentials") {
        // Token invalid or expired - clear auth and redirect to login
        localStorage.removeItem("access_token")
        localStorage.removeItem("refresh_token")
        localStorage.removeItem("auth_user")
        window.location.href = "/login"
      } else {
        toast.error(i18n.t("unauthorized_error_title"), {
          description: i18n.t("unauthorized_error_description"),
        })
      }
    } else if (error.response?.status === 403) {
      if (!window.location.pathname.includes("/login")) {
        // Forbidden
      }
    }

    return Promise.reject(error)
  },
)

export default axiosClient
